export const isCheckbox = (field) => {
    return field.type === 'checkbox';
};
export const isSelect = (field) => {
    return field.type === 'select';
};
export const isSwitch = (field) => {
    return field.type === 'switch';
};
export const isTextarea = (field) => {
    return field.type === 'textarea';
};
export const isInput = (field) => {
    return !['checkbox', 'select', 'switch', 'textarea'].includes(field.type);
};
